<template>
    <i-switch v-model="isTrue" @on-change="onChange" size="small"></i-switch>
</template>
<script>
export default {
    props:["options","value"],
    data() {
        return {
            isTrue:false
        }
    },
    watch: {
        'value':{
            handler(){
                this.isTrue = this.value;
            },
            immediate:true
        }
    },
    methods: {
        onChange(){
            this.$emit('input',this.isTrue)
            this.$emit('save')
        }
    },
}
</script>